import { useRef } from "react"
import { StyledPortionFormItem, PortionLabel } from "./styled"
import { FlexBox } from "components/Common/FlexBox"
import { formatEdamaUnit } from "utils/formater"
import DisplayedGramAndCaloriesPerUnit from "components/Common/DisplayedGramAndCaloriesPerUnit"
import PortionIcon from "components/Icons/PortionIcon"
import PortionInput from "../../PortionInput"
import UnitInputPicker from "../../UnitWheelPicker"
import { IEdamaUnit } from "model/food/types/edama.types"

export interface IProps {
  portionValue: number
  onPortionChange: (portion: number) => void
  unitValue: string
  onUnitChange: (unit: string) => void
  disabled?: boolean
  unitOptions: IEdamaUnit[]
  setIsPortionValid?: (isValid: boolean) => void
  calories?: number
  gram: null | number
}

const EdamaPortionUnitPickerFormItem = (props: IProps) => {
  const {
    onPortionChange,
    portionValue,
    unitValue,
    onUnitChange,
    disabled,
    unitOptions,
    setIsPortionValid,
    calories,
    gram,
  } = props

  const firstInputRef = useRef<HTMLInputElement>(null)
  const secondInputRef = useRef<HTMLInputElement>(null)

  const formatUnitValue = formatEdamaUnit(unitValue)
  const formatUnitOptions = unitOptions.map((unit) => ({
    label: formatEdamaUnit(unit.label),
    weight: unit.weight,
  }))

  const removeSFromUnit = (unit: string) => {
    return unit.slice(0, -3)
  }

  return (
    <StyledPortionFormItem>
      <FlexBox style={{ width: "100%" }} $justify="space-between">
        <FlexBox $alignItems="center" $gap={4}>
          <PortionIcon />
          <PortionLabel>Portion</PortionLabel>
        </FlexBox>

        <FlexBox $alignItems="center" $gap={12}>
          <PortionInput
            disabled={disabled}
            ref={firstInputRef}
            value={portionValue}
            onChange={onPortionChange}
            setIsPortionValid={setIsPortionValid}
          />

          <UnitInputPicker
            ref={secondInputRef}
            value={formatUnitValue}
            onChange={(unit) => onUnitChange(removeSFromUnit(unit))}
            options={formatUnitOptions}
          />
        </FlexBox>
      </FlexBox>

      <DisplayedGramAndCaloriesPerUnit
        calories={calories}
        portion={portionValue}
        unit={unitValue}
        gram={gram}
      />
    </StyledPortionFormItem>
  )
}

export default EdamaPortionUnitPickerFormItem
